var map = {
	"./app.png": "293b",
	"./appdownload.png": "8a38",
	"./icon_address.png": "cf8c",
	"./icon_mail.png": "bace",
	"./icon_tel.png": "4598",
	"./icon_wx.png": "bc49",
	"./officialaccount.jpg": "9c2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "24c4";